

















































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import CartModule from "@/store/modules/tienda_cart_module";
import { CartHistory } from "@/shared/dtos/CartHistory";
import { TiendaCartHistoryLocalService } from "@/shared/services/tienda_cart_history_local_service";
import { RouterNames } from "@/router/routernames";
import { ProcessoNums } from "../procesos/ProcessoNums";
import TiendaOnlineClientesModule from "@/store/modules/TiendaOnlineClientes-module";

@Component({})
export default class CartHistoryView extends Vue {
  private history: any[] = [];
  private snackbar: boolean = false;
  private snackbarText: string = "";
  private snackbarColor: string = "success";
  private searchQuery: string = "";
  private sortBy: string = "recent";
  private expandedCart: any = null;
  private deleteDialog: boolean = false;
  private clearAllDialog: boolean = false;
  private cartToDelete: any = null;

  private sortOptions = [
    { text: "Más reciente", value: "recent" },
    { text: "Más antiguo", value: "oldest" },
    { text: "Mayor precio", value: "price-high" },
    { text: "Menor precio", value: "price-low" },
    { text: "Más artículos", value: "items-most" },
    { text: "Menos artículos", value: "items-least" },
  ];

  async mounted() {
    try {
      await this.loadHistory();
    } catch (e) {
      // Ignorar
    }
    await this.preloadEstados();
  }

  private safeItems(c: any): any[] {
    if (!c || !c.items || !(c.items instanceof Array)) return [];
    return c.items;
  }

  private safeTitle(prod: any): string {
    if (!prod) return "Producto";
    var t = (prod as any).titulo_producto;
    if (t && String(t).length > 0) return String(t);
    var n = (prod as any).name;
    if (n && String(n).length > 0) return String(n);
    return "Producto";
  }

  private safeImage(prod: any): string {
    if (!prod) return "";
    var l = (prod as any).large;
    return l ? String(l) : "";
  }

  private safePrecio(prod: any): number {
    if (!prod) return 0;
    var p: any = (prod as any).precio_venta;
    return Number(p || 0);
  }

  private lineTotal(it: any): number {
    var qty = Number(it && it.qty ? it.qty : 1);
    return this.safePrecio(it ? it.product : null) * qty;
  }

  private getTotalQty(cart: any): number {
    return this.safeItems(cart).reduce((sum, item) => sum + (item.qty || 1), 0);
  }

  private async loadHistory() {
    try {
      await CartModule.loadCart();

      this.history = CartModule.cartHistory.history.map(function (h: any) {
        return h && typeof h.toPlain === "function" ? h.toPlain() : h;
      });
    } catch (e) {
      console.warn("loadHistory failed", e);
      this.history = [];
    }
  }

  get filteredHistory(): any[] {
    let filtered = [...this.history];

    // Search filter
    if (this.searchQuery) {
      const query = this.searchQuery.toLowerCase();
      filtered = filtered.filter((cart) => {
        const items = this.safeItems(cart);
        return (
          items.some((item) =>
            this.safeTitle(item.product).toLowerCase().includes(query)
          ) ||
          (cart.id && String(cart.id).includes(query))
        );
      });
    }

    // Sort
    switch (this.sortBy) {
      case "oldest":
        filtered.sort(
          (a, b) =>
            new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
        );
        break;
      case "price-high":
        filtered.sort((a, b) => this.cartSubtotal(b) - this.cartSubtotal(a));
        break;
      case "price-low":
        filtered.sort((a, b) => this.cartSubtotal(a) - this.cartSubtotal(b));
        break;
      case "items-most":
        filtered.sort(
          (a, b) => this.safeItems(b).length - this.safeItems(a).length
        );
        break;
      case "items-least":
        filtered.sort(
          (a, b) => this.safeItems(a).length - this.safeItems(b).length
        );
        break;
      default: // recent
        filtered.sort(
          (a, b) =>
            new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
        );
    }

    return filtered;
  }

  private refresh() {
    this.loadHistory().then(() => {
      this.showSnack("Actualizado", "success");
      this.preloadEstados();
    });
  }

  private cartSubtotal(c: any): number {
    var items = this.safeItems(c);
    var sum = 0;
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      sum += this.lineTotal(it);
    }
    return sum;
  }

  private formatPrice(v: any): string {
    var n = Number(v || 0);
    return n.toFixed(2);
  }

  private formatDate(val: any): string {
    if (!val) return "-";
    var d = new Date(val);
    if (isNaN(d.getTime())) return String(val);

    const now = new Date();
    const diff = now.getTime() - d.getTime();
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));

    if (days === 0) return "Hoy";
    if (days === 1) return "Ayer";
    if (days < 7) return `Hace ${days} días`;
    if (days < 30) return `Hace ${Math.floor(days / 7)} semanas`;

    return d.toLocaleDateString("es-ES", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  }

  private async restoreCart(cartPlain: any) {
    if (!cartPlain) return;
    try {
      CartModule.finalizeCurrent(true); // Finaliza el carrito actual antes de restaurar otro carrito

      var loaded = CartModule.cartHistory;
      var parsed = loaded ? loaded : new CartHistory();

      var newHistory: any[] = [];
      var i: number;
      for (i = 0; i < parsed.history.length; i++) {
        var h = parsed.history[i];
        var same =
          (h && (h as any).id ? (h as any).id : (h as any).created_at) ===
          (cartPlain.id ? cartPlain.id : cartPlain.created_at);
        if (!same) {
          newHistory.push(h);
        }
      }

      var newObj: any = { current: cartPlain, history: newHistory };
      TiendaCartHistoryLocalService.save(newObj as any);
      await CartModule.loadCart();
      await this.loadHistory();
      this.showSnack("Carrito restaurado correctamente", "success");

      // Navigate to cart
      this.$router
        .push({ name: RouterNames.carrito_compra as any })
        .catch(() => {});
    } catch (e) {
      console.error("restore failed", e);
      this.showSnack("Error al restaurar el carrito", "error");
    }
  }

  private duplicateCart(cart: any) {
    try {
      const newCart = {
        ...cart,
        id: `${cart.id}_copy_${Date.now()}`,
        created_at: new Date().toISOString(),
      };

      var loaded = TiendaCartHistoryLocalService.load();
      var parsed = loaded ? loaded : new CartHistory();
      parsed.history.unshift(newCart as any);
      TiendaCartHistoryLocalService.save(parsed);

      this.loadHistory();
      this.showSnack("Carrito duplicado", "success");
    } catch (e) {
      console.error("duplicate failed", e);
      this.showSnack("Error al duplicar", "error");
    }
  }

  private deleteHistoryByCart(cartPlain: any) {
    this.cartToDelete = cartPlain;
    this.deleteDialog = true;
  }

  private confirmDelete() {
    if (!this.cartToDelete) return;

    try {
      var loaded = TiendaCartHistoryLocalService.load();
      var parsed = loaded ? loaded : new CartHistory();

      var filtered: any[] = [];
      var i: number;
      for (i = 0; i < parsed.history.length; i++) {
        var h = parsed.history[i];
        var same =
          (h && (h as any).id ? (h as any).id : (h as any).created_at) ===
          (this.cartToDelete && this.cartToDelete.id
            ? this.cartToDelete.id
            : this.cartToDelete && this.cartToDelete.created_at);
        if (!same) {
          filtered.push(h);
        }
      }

      parsed.history = filtered as any;
      TiendaCartHistoryLocalService.save(parsed);
      this.loadHistory();
      this.showSnack("Carrito eliminado", "success");
    } catch (e) {
      console.warn("deleteHistory failed", e);
      this.showSnack("Error al eliminar", "error");
    }

    this.deleteDialog = false;
    this.cartToDelete = null;
  }

  private clearAllHistory() {
    this.clearAllDialog = true;
  }

  private confirmClearAll() {
    try {
      var loaded = TiendaCartHistoryLocalService.load();
      var parsed = loaded ? loaded : new CartHistory();
      parsed.history = [] as any;
      TiendaCartHistoryLocalService.save(parsed);
      this.loadHistory();
      this.showSnack("Histórico limpiado", "success");
    } catch (e) {
      this.showSnack("Error al limpiar", "error");
    }
    this.clearAllDialog = false;
  }

  private viewDetails(cart: any) {
    if (this.expandedCart === cart.id) {
      this.expandedCart = null;
    } else {
      this.expandedCart = cart.id;
    }
  }

  private copyId(id: any) {
    if (!id) {
      this.showSnack("Sin ID", "warning");
      return;
    }
    try {
      if (
        typeof navigator !== "undefined" &&
        navigator &&
        (navigator as any).clipboard &&
        typeof (navigator as any).clipboard.writeText === "function"
      ) {
        (navigator as any).clipboard.writeText(String(id));
        this.showSnack("ID copiado al portapapeles", "success");
      } else {
        var ta = document.createElement("textarea");
        ta.value = String(id);
        document.body.appendChild(ta);
        ta.select();
        try {
          document.execCommand("copy");
        } catch (_e) {}
        document.body.removeChild(ta);
        this.showSnack("ID: " + String(id), "info");
      }
    } catch (_e) {
      this.showSnack("ID: " + String(id), "info");
    }
  }

  private goShop() {
    this.$router.push({ name: RouterNames.tienda as any }).catch(() => {});
  }

  private goBack() {
    this.$router.back();
  }

  private showSnack(text: string, color: string = "success") {
    this.snackbarText = text;
    this.snackbarColor = color;
    this.snackbar = true;
  }

  private estadosProductos: Record<string, string> = {};

  private mapEstadoToText(estado: number | null | undefined): string {
    if (estado == null) return "Desconocido";
    switch (estado) {
      case ProcessoNums.Disponible:
        return "Disponible";
      case ProcessoNums.Reservado:
        return "No por el momento";
      case ProcessoNums.VendidoEfectivo:
      case ProcessoNums.VendidoTarjeta:
        return "No disponible";
      case ProcessoNums.Devolucion:
        return "Disponible *";
      case ProcessoNums.MermaRoto:
        return "Disponible **";
      case ProcessoNums.Envio:
        return "No por el momento";
      case ProcessoNums.PendientePago:
        return "No por el momento";
      case ProcessoNums.Reparacion:
        return "Disponible ***";
      default:
        return "Desconocido";
    }
  }

  /** Carga en bloque los estados de todos los productos presentes en this.history */
  private async preloadEstados(): Promise<void> {
    const ids = new Set<string>();
    for (const h of this.history) {
      for (const it of this.safeItems(h)) {
        const id = it.product.id;
        if (id) ids.add(String(id));
      }
    }

    // Evita peticiones repetidas: sólo pide los que no tenemos
    const pendientes = [...ids].filter((id) => !(id in this.estadosProductos));
    console.log("Preloading estados for", pendientes);
    if (pendientes.length === 0) return;

    const tareas = pendientes.map(async (id) => {
      try {
        const x =
          await TiendaOnlineClientesModule.getTiendaOnlineClientesSilence(id);
        this.$set(this.estadosProductos, id, this.mapEstadoToText(x.estado));
      } catch (e) {
        console.warn("Estado falló para", id, e);
        this.$set(this.estadosProductos, id, "Desconocido");
      }
    });
    await Promise.allSettled(tareas);
  }
}
